class VideoElement extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
  }

  connectedCallback() {
    if (this.initialized) return;

    this.video = this.querySelector("video");
    this.playControlWrapper = this.querySelector(".video__control.play");
    this.pauseControlWrapper = this.querySelector('.video__control.pause');
    this.playControl = this.playControlWrapper.querySelector('button');
    this.pauseControl = this.pauseControlWrapper.querySelector('button');

    if (!this.video || !this.playControl || !this.pauseControl) return;

    this.init();
  }

  init() {
    this.video.addEventListener("ended", () => this.showPlayButton());
    this.playControl.addEventListener("click", () => this.playVideo());
    this.pauseControl.addEventListener("click", () => this.pauseVideo());
    this.playControl.addEventListener("keydown", (e) => this.handleKey(e, "play"));
    this.pauseControl.addEventListener("keydown", (e) => this.handleKey(e, "pause"));

    this.initialized = true;
  }

  handleKey(event, action) {
    if (event.key === " " || event.key === "Enter") {
      event.preventDefault();
      if (action === "play") this.playVideo(true);
      if (action === "pause") this.pauseVideo(true);
    }
  }

  playVideo(shouldFocus = false) {
    this.video.play();
    this.playControlWrapper.hidden = true;
    this.pauseControlWrapper.hidden = false;

    if (shouldFocus) this.pauseControl.focus();
  }

  pauseVideo(shouldFocus = false) {
    this.video.pause();
    this.playControlWrapper.hidden = false;
    this.pauseControlWrapper.hidden = true;

    if (shouldFocus) this.playControl.focus();
  }

  showPlayButton() {
    this.playControlWrapper.hidden = false;
    this.pauseControlWrapper.hidden = true;
  }
}

customElements.define("video-element", VideoElement);
